const translations = {
    export: 'Export',
    exportError: 'Failed to export KML file. Please try again.',
    exportKml: 'Export KML',
    exportPdf: 'Export PDF',
    exportPdfFailed: 'Failed to export PDF file. Please try again.',
    noFlightsToExport: 'No flights selected to export.',
    spray: 'Spray',
    spread: 'Spread',
    tooManyFlights: 'Cannot export more than 500 flights at once.',
    unknown: 'Unknown'
};

export default translations;
